// extracted by mini-css-extract-plugin
export default {"container":"ThreeScene_container__34blG"};